import { scopeTimeZone } from '../../src/index';
import { useAdmin } from '../session';
import { useT } from '../i18n/provider';

/**
 * W7-OPS-GOVERNANCE (D420; Admin checklist #2): the IANA time zone a screen with no per-row market renders its instants
 * in — the operator scope's (a city's own zone; a country's when all its markets share one) — plus the console language.
 * `zone` is undefined for a platform scope or a multi-zone country: `formatMarketInstant` then renders UTC WITH the
 * marker, so an instant never reads as local time (the five screens that sliced ISO strings did exactly that).
 */
export function useScopeZone(): { readonly zone: string | undefined; readonly lang: string } {
  const { scope, markets } = useAdmin();
  const { lang } = useT();
  return { zone: scopeTimeZone(scope.current, markets), lang };
}
